module.exports = __webpack_public_path__ + "img/27.9c59bb65.jpg";